var journalize = require('journalize');

import { capfirst } from 'journalize';

import context from 'Data/text.json';

export function lastUpdatedFormat(now) {
  // format dates to ap style
  const formatted_date = journalize.apdate(now),
    formatted_time = journalize.aptime(now),
    formatted_month = journalize.apmonth(now),
    just_day = now.getDate();

  return formatted_time;
}

export function format(num) {
  return num < 10 ? '0' + num : num;
}

export const chunk = (arr, size) =>
  arr.reduce((acc, _, i) => {
    if (i % size === 0) acc.push(arr.slice(i, i + size));
    return acc;
  }, []);

export const delay = (function() {
  var timer = 0;
  return function(callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

export function APTotalVotesToCount(eevp, total_votes) {
  return eevp > 0 ? Math.round((100 * total_votes)/eevp) : NaN
}

const PARTY_SORT_ORDER = [
  'Republican',
  'Democrat',
  'Libertarian',
  'Green',
  'Independent',
  'Write-in',
];
// This is just the order for the top page
const PARTY_SORT_ORDER_TOP = [
  'Democrat',
  'Republican',
  'Libertarian',
  'Green',
  'Independent',
  'Write-in',
];

// If we need light blue #99d2da; background-color:rgba(153, 210, 218, .1)
// If we need dark blue #325ba8; background-color:rgba(90, 137, 204, .1)

const TT_directory_slugs = [
  { office: 'Texas House', 'directory-slug': 'tx-house' },
  { office: 'Texas Senate', 'directory-slug': 'tx-senate' },
  { office: 'U.S. House', 'directory-slug': 'us-house' },
  { office: 'State Board of Education', 'directory-slug': 'sboe' },
];

export function get_directory_slug(office) {
  return TT_directory_slugs.filter(slug => slug.office == office);
}

export function sort_candidates_by_party(candidates, type) {
  if (type == 'top_races')
  {
    return candidates.sort(
      (a, b) =>
        PARTY_SORT_ORDER.indexOf(a.party) - PARTY_SORT_ORDER.indexOf(b.party)
    );
  }

  else {
    return candidates.sort(
      (a, b) =>
        PARTY_SORT_ORDER.indexOf(a.party) - PARTY_SORT_ORDER.indexOf(b.party)
    );
  }
 
}

export function sort_candidates_by_votes(candidates) {
  return candidates.sort(
    (a, b) =>
      b.votes - a.votes
  );
}

export function alert_conditionals(vote_pct, cand_num) {
  if (vote_pct == 0 && cand_num > 1) {
    return context.label_conditionals['zero-results'];
  } else if (vote_pct > 0 && vote_pct <= 50 && cand_num > 1) {
    return context.label_conditionals['more-than-0-less-than-50'];
  } else if (vote_pct > 50 && vote_pct < 90 && cand_num > 1) {
    return context.label_conditionals['more-than-50-no-winner'];
  } else if (vote_pct >= 90 && cand_num > 1) {
    return context.label_conditionals['all-results-in-no-winner'];
  } else if (cand_num == 1) {
    return context.label_conditionals['uncontested'];
  }
}

export function alert_winners(result, office) {
  if (result == 'winner' && office != 'President') {
    return context.winner_conditionals['winner'];
  } else if (result == 'winner' && office == 'President') {
    return context.winner_conditionals['winner_prez'];
  } else if (result == 'uncontested') {
    return context.winner_conditionals['uncontested'];
  } else if (result == 'runoff') {
    return context.winner_conditionals['runoff'];
  }
}

export function text_conditionals(vote_pct, cand_num) {
  if (vote_pct == 0 && cand_num > 1) {
    return context.text_conditionals['zero-results'];
  } else if (vote_pct > 1 && vote_pct <= 50 && cand_num > 1) {
    return context.text_conditionals['more-than-0-less-than-50'];
  } else if (vote_pct > 50 && vote_pct < 90 && cand_num > 1) {
    return context.text_conditionals['more-than-50-no-winner'];
  } else if (vote_pct >= 90 && cand_num > 1) {
    return context.text_conditionals['all-results-in-no-winner'];
  } else if (cand_num == 1) {
    return context.text_conditionals['uncontested'];
  }
}

export function text_conditional_winner_zero(vote_pct, cand_num) {
  if (vote_pct == 0 && cand_num > 1) {
    return context.text_conditionals['zero-results_winner'];
  } else {
    return ``;
  }
}

export function determineDistrictTitle(contest) {
  return `${contest.office} ${
    contest.office === 'President' ||
    contest.division_type === 'class' ||
    contest.division_type === 'statewide'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}

export function getDistrictNum(division_type, division_number) {
  return capfirst(division_type) + ' ' + division_number
}

export function determineContestTitle(contest) {
  if (contest.division_type === 'statewide' || contest.division_type === 'seat')
    return '';

  return determineDistrictTitle(contest);
}

export function determineContestTitleYourRaces(contest) {
  return determineDistrictTitle(contest);
}